import { jsx as o, jsxs as F } from "react/jsx-runtime";
import { useCallback as b, useEffect as E, useMemo as H, Fragment as k } from "react";
import { $ as G, a0 as j, a1 as O, a2 as $, a3 as K, a4 as U, a5 as _, a6 as q, a7 as J, a8 as Q } from "./Slider-vVmtecg6.js";
import { Box as W, useTheme as X, Stack as Y } from "@mui/material";
import { s as I } from "./spacings-C27fg6SF.js";
import { T as Z } from "./Typography-HkIo7ajX.js";
import "@mui/material/Typography";
var d = /* @__PURE__ */ ((e) => (e[e.xs = 337] = "xs", e[e.sm = 344] = "sm", e[e.md = 600] = "md", e[e.lg = 800] = "lg", e))(d || {});
const B = ({ children: e, inViewCallback: i, stepId: t }) => /* @__PURE__ */ o(W, { id: t, children: /* @__PURE__ */ o(
  G,
  {
    placeholder: /* @__PURE__ */ o(
      W,
      {
        height: 450,
        mb: 2,
        borderRadius: "12px"
      }
    ),
    threshold: 0.01,
    delay: 0,
    shouldTriggerOnce: !1,
    inViewCallback: i,
    children: e
  }
) }), f = (e) => {
  const i = { href: "#", host: "" };
  try {
    return e ? new URL(e.includes("http") ? e : `https://${e}`) : i;
  } catch {
    return i;
  }
}, ee = ({ goToLabel: e, onClick: i, stepGoToLink: t, styling: n }) => {
  const h = X();
  return /* @__PURE__ */ o(
    Y,
    {
      my: I[n.marginTop],
      direction: "row",
      spacing: I.xxs,
      alignItems: "center",
      children: /* @__PURE__ */ o(
        Z,
        {
          variant: "text",
          fontWeight: n.fontWeight,
          size: n.fontSize,
          children: /* @__PURE__ */ F("bdi", { children: [
            e,
            " ",
            /* @__PURE__ */ o(
              "a",
              {
                href: f(t).href,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (a) => {
                  a.preventDefault(), a.stopPropagation(), i();
                },
                style: { cursor: "pointer", color: h.palette.primary[600], textDecoration: "none" },
                children: f(t).host || f(t).href
              }
            )
          ] })
        }
      )
    }
  );
}, p = {
  xs: {
    title: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "xl",
      variant: "text"
    },
    description: {
      fontSize: "xs",
      fontSizeInPx: "12px",
      fontWeight: "regular",
      marginTop: "xxs",
      lineHeight: "18px",
      fontWeightInPx: 400
    },
    goToLabel: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "lg"
    },
    numberIcon: {
      containerSize: "20px",
      fontSize: "xs",
      fontWeight: "semibold",
      marginRight: "xs",
      variant: "text"
    },
    action: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "lg",
      spacing: "sm",
      multipleActionsTitleFontSize: "sm",
      multipleActionsTitleFontWeight: "semibold",
      titleMarginTop: "lg"
    },
    screenshot: {
      marginTop: "md",
      fontSize: "xs"
    }
  },
  sm: {
    title: {
      fontSize: "sm",
      fontWeight: "semibold",
      marginTop: "xl",
      variant: "text"
    },
    description: {
      fontSize: "xs",
      fontSizeInPx: "12px",
      fontWeight: "regular",
      marginTop: "xs",
      lineHeight: "18px",
      fontWeightInPx: 400
    },
    goToLabel: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "lg"
    },
    numberIcon: {
      containerSize: "24px",
      fontSize: "xs",
      fontWeight: "semibold",
      marginRight: "xs",
      variant: "text"
    },
    action: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "sm",
      spacing: "sm",
      multipleActionsTitleFontSize: "sm",
      multipleActionsTitleFontWeight: "semibold",
      titleMarginTop: "lg"
    },
    screenshot: {
      marginTop: "md",
      fontSize: "sm"
    }
  },
  md: {
    title: {
      fontSize: "xl",
      fontWeight: "bold",
      marginTop: "4xl",
      variant: "text"
    },
    description: {
      fontSize: "sm",
      fontSizeInPx: "14px",
      fontWeight: "medium",
      marginTop: "sm",
      lineHeight: "20px",
      fontWeightInPx: 400
    },
    goToLabel: {
      fontSize: "sm",
      fontWeight: "medium",
      marginTop: "xl"
    },
    numberIcon: {
      containerSize: "24px",
      fontSize: "xs",
      fontWeight: "semibold",
      marginRight: "lg",
      variant: "text"
    },
    action: {
      fontSize: "sm",
      fontWeight: "medium",
      marginTop: "lg",
      spacing: "lg",
      multipleActionsTitleFontSize: "sm",
      multipleActionsTitleFontWeight: "semibold",
      titleMarginTop: "xl"
    },
    screenshot: {
      marginTop: "lg",
      fontSize: "md"
    }
  },
  lg: {
    title: {
      fontSize: "xs",
      fontWeight: "medium",
      marginTop: "xl",
      variant: "heading"
    },
    description: {
      fontSizeInPx: "18px",
      fontWeightInPx: 400,
      fontSize: "lg",
      fontWeight: "medium",
      marginTop: "sm",
      lineHeight: "28px"
    },
    goToLabel: {
      fontSize: "xl",
      fontWeight: "semibold",
      marginTop: "3xl"
    },
    numberIcon: {
      variant: "text",
      containerSize: "39px",
      fontSize: "lg",
      fontWeight: "semibold",
      marginRight: "xl"
    },
    action: {
      fontSize: "md",
      fontWeight: "medium",
      marginTop: "2xl",
      spacing: "xl",
      multipleActionsTitleFontSize: "xl",
      multipleActionsTitleFontWeight: "semibold",
      titleMarginTop: "2xl"
    },
    screenshot: {
      marginTop: "2xl",
      fontSize: "md"
    }
  }
}, m = /* @__PURE__ */ new Map(), te = () => {
  const e = b((t) => {
    if (m.has(t))
      return;
    const n = document.createElement("link");
    n.href = t, n.rel = "stylesheet", n.type = "text/css", document.head.appendChild(n), m.set(t, n);
  }, []), i = b(() => {
    m.forEach((t) => {
      document.head.removeChild(t);
    }), m.clear();
  }, []);
  return { loadFont: e, cleanup: i, size: m.size };
}, ge = ({
  goToLabel: e,
  isRtl: i,
  shouldIgnoreCustomTags: t,
  brandKitHighlightColor: n,
  shouldShowMagicAnimation: h,
  disableActions: a,
  amountOfStepsWithoutLazyLoad: v,
  onGoToClick: y = () => {
  },
  containerWidth: g,
  stepsProgress: C = {},
  font: c,
  isStepsGenerating: D,
  onCtaClick: P,
  steps: l = [],
  jumpToStepInVideo: A = () => {
  },
  onWatchNewStep: N = () => {
  }
}) => {
  const { loadFont: x } = te();
  E(() => {
    c.url && x(c.url);
  }, [c, x]);
  const V = j(l), w = O(l), u = H(() => g < Number(d.sm) ? p.xs : g < Number(d.md) ? p.sm : g < Number(d.lg) ? p.md : p.lg, [g]);
  return /* @__PURE__ */ o($, { isRtl: i, children: l.map((r, s) => {
    const S = K(l[0].kind), L = U(s, S), T = _(r.kind, s), M = s === V && r.url, z = /* @__PURE__ */ F(k, { children: [
      !!M && /* @__PURE__ */ o(q, { stepId: r.id, children: /* @__PURE__ */ o(
        ee,
        {
          stepGoToLink: r.url,
          styling: u.goToLabel,
          goToLabel: e,
          onClick: () => {
            y(r.url);
          }
        }
      ) }),
      /* @__PURE__ */ o(
        J,
        {
          step: r,
          styling: u,
          isFirstStep: s === 0,
          originalIndex: T,
          stepNumber: L,
          disableActions: a,
          isRtl: i,
          shouldIgnoreCustomTags: t,
          stepNumberingColor: w,
          brandKitHighlightColor: n,
          shouldShowMagicAnimation: h,
          steps: l,
          font: c,
          stepProgress: C[T] || 100,
          isStepsGenerating: D,
          onCtaClick: P,
          jumpToStepInVideo: A
        }
      )
    ] }, r.id);
    return s < v - 1 ? z : (
      // id here are using in IntersectionObserver. please do not remove id
      /* @__PURE__ */ o(
        B,
        {
          stepId: r.id,
          inViewCallback: () => {
            if (r.kind !== Q.Step)
              return;
            const R = s + S;
            N(R);
          },
          children: z
        },
        r.id
      )
    );
  }) });
};
export {
  ge as D
};
